import { State as ListState, reducer as listReducer } from "./list";
import { combineReducers } from "redux";

export interface State {
    posCatalogue: {
        list: ListState;
    };
}

export const reducer = combineReducers({
    list: listReducer,
});
